import gql from "graphql-tag";

export const employeeQuery = gql`
  query employee($userId: ID!) {
    employee(userId: $userId) {
      isActive
      firstName
      lastName
      email
      isDeleted
      roles {
        id
      }
      manager {
        id
        name
      }
    }
    roles {
      id
      name
      code
      parent {
        code
      }
    }
    managersAvailableForEmployee(userId: $userId) {
      id
      name
    }
  }
`;
